import React, { FC } from "react";
import Link from "components/Link";
import "../../../styles/styles.css";
import { Video } from "data/types";

/* Utils */
const isYouTube = (url: string) =>
  /youtube\.com|youtu\.be/.test(url);

const isTikTok = (url: string) =>
  /tiktok\.com/.test(url);

const isFacebook = (url: string) =>
  /facebook\.com|fb\.watch/.test(url);

const getFacebookEmbedUrl = (url: string) => {
  return `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(
    url
  )}&show_text=false&width=560`
};

const getYouTubeId = (url: string) => {
  const match = url.match(
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
  );
  return match && match[7]?.length === 11 ? match[7] : null;
};

const getTikTokId = (url: string) => {
  const match = url.match(/video\/(\d+)/);
  return match ? match[1] : null;
};

export interface CardVideoProps {
  video: Video;
}

const CardVideo: FC<CardVideoProps> = ({ video }) => {
  const { title, videoUrl } = video;

  const youtubeId = isYouTube(videoUrl) ? getYouTubeId(videoUrl) : null;
  const tiktokId = isTikTok(videoUrl) ? getTikTokId(videoUrl) : null;
  const facebookEmbedUrl = isFacebook(videoUrl) ? getFacebookEmbedUrl(videoUrl) : null;

  return (
    <div className="nc-Card10V2 relative flex flex-col">
      <b className="mb-2">{title}</b>

      <div className="relative w-full aspect-w-16 aspect-h-9 rounded-3xl overflow-hidden bg-black">

        {/* Embed sans autoplay (preview) */}
        {youtubeId && (
          <iframe
            src={`https://www.youtube.com/embed/${youtubeId}`}
            title={title}
            className="w-full h-full pointer-events-none"
            allow="encrypted-media"
          />
        )}

        {tiktokId && (
          <iframe
            src={`https://www.tiktok.com/embed/v2/${tiktokId}`}
            title={title}
            className="w-full h-full pointer-events-none"
          />
        )}

        {facebookEmbedUrl && (
        <iframe
          src={facebookEmbedUrl}
          title={title}
          className="w-full h-full"
          allow="autoplay; fullscreen; encrypted-media"
          allowFullScreen
        />
      )}

        {/* Overlay Play */}
        <Link
          href={`/video?videoUrl=${encodeURIComponent(videoUrl)}`}
          className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30 hover:bg-opacity-20 transition rounded-3xl z-10"
        >
          <span className="text-white text-5xl font-bold">▶</span>
        </Link>
      </div>
    </div>
  );
};

export default CardVideo;
